import JsBarcode from 'jsbarcode'
export function createbarcode(serialnumber){
    return new Promise(async function(resolve,reject){
        console.log('inside barcode')
        let options={width:3,height:40,fontSize:50}
        let barcode=JsBarcode("#barcode", serialnumber,options);
        console.log('inside create barcode')
        resolve(barcode)
        })
    }